import _objectSpread from "@babel/runtime/helpers/objectSpread2";

/**
 *
 * @param data
 * @param options
 */
export function join(geoData, options) {
  var sourceField = options.sourceField,
      targetField = options.targetField,
      data = options.data;
  var dataObj = {};
  data.forEach(function (element) {
    // 属性数据
    dataObj[element[sourceField]] = element;
  });
  geoData.dataArray = geoData.dataArray.map(function (item) {
    var joinName = item[targetField];
    return _objectSpread(_objectSpread({}, item), dataObj[joinName]);
  });
  return geoData;
}